import React from 'react'
import { View, ScrollView } from 'react-native'
import PropTypes from 'prop-types'

import PreferredLanes from '../../PreferredLanes'
import QuickNumbers from '../../QuickNumbers'
import EventsSection from '../../EventsSection'

const DashboardTemplate = ({ lanes, quickNumbers, events, loadingQuickNumbers, loadingEvents, loadingPreferredLanes }) => {
  return (
    <ScrollView contentContainerStyle={{ paddingHorizontal: 20, paddingBottom: 20, width: '100%' }} showsVerticalScrollIndicator={false}>
      <View>
        <View>
          <PreferredLanes
            loading={loadingPreferredLanes}
            lanes={lanes}
          />
          <QuickNumbers
            loading={loadingQuickNumbers}
            quickNumbers={quickNumbers}
          />
        </View>
        <View>
          <EventsSection
            events={events}
            loading={loadingEvents}
          />
        </View>
      </View>
    </ScrollView>
  )
}

DashboardTemplate.propTypes = {
  lanes: PropTypes.array.isRequired,
  quickNumbers: PropTypes.object.isRequired,
  events: PropTypes.array.isRequired,
  loadingQuickNumbers: PropTypes.bool,
  loadingEvents: PropTypes.bool,
  loadingPreferredLanes: PropTypes.bool
}

DashboardTemplate.defaultProps = {
  lanes: [],
  quickNumbers: [],
  events: [],
  loadingQuickNumbers: false,
  loadingEvents: false,
  loadingPreferredLanes: false
}

export default DashboardTemplate
